import { combineReducers } from "redux";
import getLoadingReducer from "./getLoadingReducer";
import resetOnRefresh from "./resetOnRefreshReducer";

const loadingReducer = combineReducers({
    getLoading: getLoadingReducer,
    resetOnRefresh: resetOnRefresh
});

export default loadingReducer;